import type { ReactNode } from 'react';
import { WarehouseContent } from './WarehouseContent';
import { WarehousePageHeader } from './WarehousePageHeader';
import { WarehousePageProviders } from './WarehousePageProviders';

type WarehousePageProps = { warehouseId: number; metadata: (warehouseName: string) => ReactNode };

/** Warehouse details: the header appears with the warehouse; the content owns loading, failure and the grid. */
export default function WarehousePage({ warehouseId, metadata }: WarehousePageProps) {
  return (
    <WarehousePageProviders warehouseId={warehouseId}>
      <WarehousePageHeader metadata={metadata} />
      <WarehouseContent />
    </WarehousePageProviders>
  );
}
